module.exports = __webpack_public_path__ + "img/2-1_07.46e3e6a1.jpg";